import React from "react";
import { LoadingPage } from "../../../components/LoadingPage";
import CardContentModal from "../../../components/modal/CardContentModal";
import ConciergeModal from "../../../components/modal/ConciergeModal";
import CouponListModal from "../../../components/modal/CouponListModal";
import PetalBackground from "../../../components/PetalBackground";
import SnowBackground from "../../../components/SnowBackground";
import AroundStore from "../AroundStore";
import EventContent from "../content/eventContent";
import StoreCouponDetailContent from "../content/storeCouponDetailContent";
import EventSlider from "../EventSlider";
import Footer from "../footer";
import FooterButton from "../footerButton";
import Header from "../header";
import MasterStore from "../MasterStore";
import SectorCategory from "../SectorCategory";
import StoreContents from "../StoreContents";
import { Style } from "./style";
import { UseMainViewProps } from "./type";

export default function MainView({ queries, hook }: UseMainViewProps) {
  const getBackground = () => {
    if (hook.theme.background === "snow") {
      return <SnowBackground />;
    } else if (hook.theme.background === "spring") {
      return <PetalBackground />;
    } else {
      return;
    }
  };

  return hook.loading ? (
    <LoadingPage />
  ) : (
    <>
      <Style>
        <div className="knockContainer">
          <Header
            storeList={queries.storeList}
            kioskMode={hook.kioskMode}
            deviceArea={queries.deviceArea}
          />
          {hook.voucherContent ? (
            <div className="voucherContentWrap">
              <StoreCouponDetailContent
                cardData={hook.selectedCard}
                lang={hook.lang}
                setVoucherContent={hook.setVoucherContent}
              />
            </div>
          ) : (
            <>
              <EventSlider
                storeList={queries.storeList}
                lang={hook.lang}
                theme={hook.theme}
                adverEventList={queries.eventList || []}
              />
              <MasterStore
                storeList={queries.storeList}
                lang={hook.lang}
                currentDate={hook.currentDate}
                navigateSector={hook.navigateSector}
                openCard={hook.openCard}
              />
              <div className="line" />
              {queries.storeList &&
                queries.storeList.main_section.length > 0 && (
                  <>
                    <SectorCategory
                      storeList={queries.storeList}
                      lang={hook.lang}
                      currentDate={hook.currentDate}
                      selectedCategory={hook.selectedCategory}
                      navigateSector={hook.navigateSector}
                      navigateStore={hook.navigateStore}
                      theme={hook.theme}
                    />
                    <div className="line" />
                    <StoreContents
                      storeList={queries.storeList}
                      lang={hook.lang}
                      currentDate={hook.currentDate}
                      navigateSector={hook.navigateSector}
                      theme={hook.theme}
                    />
                  </>
                )}
              <div className="line" />
              {queries.aroundCard && queries.aroundCard.length > 0 && (
                <AroundStore
                  aroundCardList={queries.aroundCard}
                  lang={hook.lang}
                  openVoucher={hook.openVoucher}
                  theme={hook.theme}
                />
              )}
            </>
          )}

          {/* 광고,이벤트 */}
          <EventContent
            eventList={queries.eventList}
            adverList={queries.adverList}
            timeSectorRecommend={queries.timeSectorRecommend}
            navigateAdStore={hook.navigateAdStore}
          />
          {/* 하단 버튼 */}
          <div className="footerContainer">
            <FooterButton
              storeList={queries.storeList}
              concierge={queries.concierge}
              interphoneAreaList={queries.interphoneArea || []}
              useInterphone={queries.useInterphone}
              navigateAdStore={hook.navigateAdStore}
              openConciergeModal={hook.openConciergeModal}
            />
            <Footer
              concierge={queries.concierge}
              interphoneAreaList={queries.interphoneArea || []}
              openConciergeModal={hook.openConciergeModal}
              useInterphone={queries.useInterphone}
            />
          </div>
          {getBackground()}
        </div>
      </Style>

      <ConciergeModal
        concierge={queries.concierge!}
        resetTimer={hook.modalResetTimer}
      />

      <CardContentModal
        cardData={hook.selectedCard}
        resetTimer={hook.modalResetTimer}
        type={"main"}
      />
      <CouponListModal
        coupons={queries.storeList ? queries.storeList.coupon_section : []}
        resetTimer={hook.modalResetTimer}
        modalType="main"
      />
    </>
  );
}
